module.exports = __webpack_public_path__ + "static/img/tdf-app.46dbc45.png";